import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
              热门专题
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
              精心策划的电影专题，发现你的下一部心头好
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
              >
                <div className="relative overflow-hidden h-52">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    title={item.title}
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-bold text-foreground-900 font-heading mb-1.5 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}